import type { TeamRole } from '@indutrust/shared-model';
import { canManageTeam } from './team-role-cap.util';

/**
 * Whether the actor may edit the Company legal name (R4 bucket 2).
 * Owner-only; Manager and Viewer are read-only on this field.
 */
export function canEditCompanyLegalName(actor: TeamRole): boolean {
  return actor === 'owner';
}

/**
 * Whether the actor may mutate Company profile fields (contacts, operational
 * buckets). Alias for {@link canManageTeam} — Owner and Manager write;
 * Viewer is read-only.
 */
export function canMutateCompanyProfile(actor: TeamRole): boolean {
  return canManageTeam(actor);
}
